function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SupplyTemplate = require('./supply.template');
var _require = require('../manual-block-production'),
  EXPLORER_ENSURE_TEST_MODE_REQUEST = _require.EXPLORER_ENSURE_TEST_MODE_REQUEST,
  EXPLORER_PRODUCE_BLOCK_REQUEST = _require.EXPLORER_PRODUCE_BLOCK_REQUEST,
  EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST = _require.EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST;
var _require2 = require('../simulation-transaction'),
  parseSimulationFeeSaito = _require2.parseSimulationFeeSaito,
  addFeeTransaction = _require2.addFeeTransaction;
var _require3 = require('../peer/client'),
  sendExplorerPeerRequest = _require3.sendExplorerPeerRequest;
function formatProduceError(err) {
  if (!err) {
    return 'Block production failed.';
  }
  if (typeof err === 'string') {
    return err;
  }
  if (err !== null && err !== void 0 && err.message) {
    return err.message;
  }
  return 'Block production failed.';
}

/**
 * Manual block production:
 *   send one produce request → wait for server → refresh supply
 */
var Supply = /*#__PURE__*/function () {
  function Supply(app, mod) {
    _classCallCheck(this, Supply);
    this.app = app;
    this.mod = mod;
    this.container = '.explorer-view';
    this.fullWidth = false;
    this.showExactSupplyIntegers = false;
    this.producing = false;
    this.produceError = null;
  }
  return _createClass(Supply, [{
    key: "shouldShowBlockControls",
    value: function shouldShowBlockControls() {
      if (typeof this.mod.canExposeManualBlockProduction === 'function') {
        return this.mod.canExposeManualBlockProduction();
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.mod.supplyComponent = this;
      this.paint();
      if (!this.mod.supplyReady && this.mod.explorerPeer) {
        this.mod.fetchSupplyData(this.app, this.mod.explorerPeer);
      }
    }
  }, {
    key: "paint",
    value: function paint() {
      var loading = !this.mod.supplyReady;
      var error = this.mod.supplyError ? this.app.browser.escapeHTML(this.mod.supplyError) : null;
      var view = this.mod.supplyView || null;
      this.app.browser.replaceElementContentBySelector(SupplyTemplate({
        loading: loading,
        error: error,
        produceError: this.produceError ? this.app.browser.escapeHTML(this.produceError) : null,
        columns: (view === null || view === void 0 ? void 0 : view.columns) || [],
        rows: (view === null || view === void 0 ? void 0 : view.rows) || [],
        hasData: Boolean(view === null || view === void 0 ? void 0 : view.hasData),
        fullWidth: this.fullWidth,
        showExactSupplyIntegers: this.showExactSupplyIntegers,
        showBlockControls: this.shouldShowBlockControls(),
        produceBlockRequest: EXPLORER_PRODUCE_BLOCK_REQUEST,
        produceBlockWithGtRequest: EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST
      }), this.container);
      this.attachEvents();
      this.mod.renderSimulationToolbar();
    }
  }, {
    key: "setProducingState",
    value: function setProducingState(isProducing) {
      this.producing = isProducing;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.explorer-supply-admin-controls button.explorer-back-link').forEach(function (button) {
        button.disabled = isProducing;
      });
      var feeInput = root.querySelector('[data-supply-fee-input]');
      if (feeInput) {
        feeInput.disabled = isProducing;
      }
    }
  }, {
    key: "clearProduceError",
    value: function clearProduceError() {
      this.produceError = null;
    }
  }, {
    key: "showProduceError",
    value: function showProduceError(message) {
      this.produceError = message;
      this.mod.setSimulationToolbarMessage(message, {
        isError: true
      });
      this.paint();
    }
  }, {
    key: "clearFeeError",
    value: function clearFeeError() {
      var root = document.querySelector(this.container);
      var feeInput = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-input]');
      if (feeInput) {
        feeInput.classList.remove('explorer-supply-fee-input-error');
        feeInput.removeAttribute('aria-invalid');
      }
    }
  }, {
    key: "showFeeError",
    value: function showFeeError(message) {
      var root = document.querySelector(this.container);
      var feeInput = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-input]');
      if (feeInput) {
        feeInput.classList.add('explorer-supply-fee-input-error');
        feeInput.setAttribute('aria-invalid', 'true');
        feeInput.focus();
      }
      this.hideFeeSuccess();
      console.warn('Explorer: invalid simulation fee', message);
    }
  }, {
    key: "resetFeeDiagnostics",
    value: function resetFeeDiagnostics() {
      var root = document.querySelector(this.container);
      var panel = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-diagnostics]');
      if (!panel) {
        return;
      }
      panel.hidden = false;
      panel.querySelectorAll('[data-fee-step]').forEach(function (item) {
        item.dataset.state = 'pending';
        var icon = item.querySelector('[data-fee-step-icon]');
        if (icon) {
          icon.textContent = '…';
        }
      });
      var success = panel.querySelector('[data-supply-fee-success]');
      if (success) {
        success.hidden = true;
      }
    }
  }, {
    key: "updateFeeDiagnostic",
    value: function updateFeeDiagnostic(step, ok) {
      var root = document.querySelector(this.container);
      var item = root === null || root === void 0 ? void 0 : root.querySelector("[data-fee-step=\"".concat(step, "\"]"));
      if (!item) {
        return;
      }
      item.dataset.state = ok ? 'pass' : 'fail';
      var icon = item.querySelector('[data-fee-step-icon]');
      if (icon) {
        icon.textContent = ok ? '✓' : '✗';
      }
    }
  }, {
    key: "showFeeSuccess",
    value: function showFeeSuccess() {
      var root = document.querySelector(this.container);
      var success = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-success]');
      if (success) {
        success.hidden = false;
      }
    }
  }, {
    key: "hideFeeSuccess",
    value: function hideFeeSuccess() {
      var root = document.querySelector(this.container);
      var success = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-success]');
      if (success) {
        success.hidden = true;
      }
    }
  }, {
    key: "hideFeeDiagnostics",
    value: function hideFeeDiagnostics() {
      var root = document.querySelector(this.container);
      var panel = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-diagnostics]');
      if (panel) {
        panel.hidden = true;
      }
      this.hideFeeSuccess();
    }
  }, {
    key: "createTransaction",
    value: function () {
      var _createTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _feeInput$value,
          _this = this;
        var root, feeInput, feeValue, parsed, feeNolan, balance, _this$app$browser, message, _this$app$browser2, _message, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.producing || !this.shouldShowBlockControls())) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (this.mod.explorerPeer) {
                _context.n = 2;
                break;
              }
              this.showFeeError('Explorer peer is not connected.');
              return _context.a(2);
            case 2:
              root = document.querySelector(this.container);
              feeInput = root === null || root === void 0 ? void 0 : root.querySelector('[data-supply-fee-input]');
              feeValue = (_feeInput$value = feeInput === null || feeInput === void 0 ? void 0 : feeInput.value) !== null && _feeInput$value !== void 0 ? _feeInput$value : '';
              parsed = parseSimulationFeeSaito(feeValue);
              this.clearFeeError();
              if (!parsed.error) {
                _context.n = 3;
                break;
              }
              this.showFeeError(parsed.error);
              return _context.a(2);
            case 3:
              feeNolan = this.app.wallet.convertSaitoToNolan(parsed.feeSaito);
              if (!(feeNolan > 0n)) {
                _context.n = 8;
                break;
              }
              balance = 0n;
              _context.p = 4;
              _context.n = 5;
              return this.app.wallet.getBalance();
            case 5:
              balance = _context.v;
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('Explorer: failed to read wallet balance', _t);
              message = 'Unable to read wallet balance.';
              if ((_this$app$browser = this.app.browser) !== null && _this$app$browser !== void 0 && _this$app$browser.alert) {
                this.app.browser.alert(message);
              } else {
                this.showFeeError(message);
              }
              return _context.a(2);
            case 7:
              if (!(balance < feeNolan)) {
                _context.n = 8;
                break;
              }
              _message = 'Your wallet does not have enough SAITO to pay this fee.';
              if ((_this$app$browser2 = this.app.browser) !== null && _this$app$browser2 !== void 0 && _this$app$browser2.alert) {
                this.app.browser.alert(_message);
              } else {
                this.showFeeError(_message);
              }
              return _context.a(2);
            case 8:
              this.setProducingState(true);
              this.resetFeeDiagnostics();
              _context.p = 9;
              _context.n = 10;
              return this.sendManualTestingRequest(EXPLORER_ENSURE_TEST_MODE_REQUEST);
            case 10:
              _context.n = 11;
              return addFeeTransaction(this.app, parsed.feeSaito, this.mod.explorerPeer, function (step, ok) {
                _this.updateFeeDiagnostic(step, ok);
              });
            case 11:
              _context.n = 13;
              break;
            case 12:
              _context.p = 12;
              _t2 = _context.v;
              console.error('Explorer: simulation transaction failed', _t2);
              this.showFeeError((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Failed to create transaction.');
            case 13:
              _context.p = 13;
              this.setProducingState(false);
              return _context.f(13);
            case 14:
              return _context.a(2);
          }
        }, _callee, this, [[9, 12, 13, 14], [4, 6]]);
      }));
      function createTransaction() {
        return _createTransaction.apply(this, arguments);
      }
      return createTransaction;
    }()
  }, {
    key: "sendManualTestingRequest",
    value: function sendManualTestingRequest(request) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        sendExplorerPeerRequest(_this2.app, request, {
          data: {
            request: request
          },
          peer: _this2.mod.explorerPeer,
          callback: function callback(response) {
            if (response !== null && response !== void 0 && response.err) {
              reject(response.err);
              return;
            }
            if (!(response !== null && response !== void 0 && response.success)) {
              reject(new Error((response === null || response === void 0 ? void 0 : response.error) || 'Block production failed.'));
              return;
            }
            resolve(response);
          }
        });
      });
    }
  }, {
    key: "produceBlock",
    value: function () {
      var _produceBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(request) {
        var withGt, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.producing || !this.shouldShowBlockControls())) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (this.mod.explorerPeer) {
                _context2.n = 2;
                break;
              }
              this.showProduceError('Explorer peer is not connected.');
              return _context2.a(2);
            case 2:
              withGt = request === EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST;
              this.clearProduceError();
              this.mod.clearSimulationToolbarMessage();
              this.setProducingState(true);
              if (withGt) {
                this.mod.beginManualProductionUI(request);
              } else {
                this.mod.setSimulationToolbarMessage('Waiting for block production...');
              }
              _context2.p = 3;
              _context2.n = 4;
              return this.sendManualTestingRequest(request);
            case 4:
              _context2.n = 5;
              return this.mod.refreshSupplyAfterProduce();
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t3 = _context2.v;
              this.showProduceError(formatProduceError(_t3));
            case 7:
              _context2.p = 7;
              if (withGt) {
                this.mod.stopManualProductionUI();
              } else {
                this.mod.clearSimulationToolbarMessage();
              }
              this.setProducingState(false);
              return _context2.f(7);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 6, 7, 8]]);
      }));
      function produceBlock(_x) {
        return _produceBlock.apply(this, arguments);
      }
      return produceBlock;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.explorer-supply-block-link').forEach(function (link) {
        link.onclick = function (event) {
          var _link$closest;
          event.preventDefault();
          var hash = (_link$closest = link.closest('[data-block-hash]')) === null || _link$closest === void 0 || (_link$closest = _link$closest.dataset) === null || _link$closest === void 0 ? void 0 : _link$closest.blockHash;
          if (hash) {
            _this3.mod.renderBlock(hash, {
              pushState: true,
              animate: true
            });
          }
        };
      });
      root.querySelectorAll('[data-produce-block-request]').forEach(function (button) {
        button.onclick = function (event) {
          event.preventDefault();
          _this3.produceBlock(button.dataset.produceBlockRequest);
        };
      });
      var createTransactionButton = root.querySelector('[data-supply-create-transaction]');
      var feeInput = root.querySelector('[data-supply-fee-input]');
      if (createTransactionButton) {
        createTransactionButton.onclick = function (event) {
          event.preventDefault();
          _this3.createTransaction();
        };
      }
      if (feeInput) {
        feeInput.onkeydown = function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            _this3.createTransaction();
          }
        };
        feeInput.oninput = function () {
          _this3.clearFeeError();
        };
      }
      var widthToggle = root.querySelector('[data-supply-width-toggle]');
      var supplyContainer = root.querySelector('.explorer-supply-page .explorer-container');
      if (widthToggle && supplyContainer) {
        var toggleFullWidth = function toggleFullWidth() {
          _this3.fullWidth = !_this3.fullWidth;
          supplyContainer.classList.toggle('full-width', _this3.fullWidth);
          var label = _this3.fullWidth ? 'Collapse supply dashboard' : 'Expand supply dashboard';
          widthToggle.setAttribute('aria-label', label);
          widthToggle.setAttribute('title', label);
          widthToggle.setAttribute('aria-expanded', _this3.fullWidth ? 'true' : 'false');
        };
        widthToggle.onclick = toggleFullWidth;
        widthToggle.onkeydown = function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleFullWidth();
          }
        };
      }
      var exactToggle = root.querySelector('[data-supply-exact-toggle]');
      if (exactToggle) {
        exactToggle.onclick = function () {
          _this3.showExactSupplyIntegers = !_this3.showExactSupplyIntegers;
          exactToggle.classList.toggle('is-active', _this3.showExactSupplyIntegers);
          exactToggle.setAttribute('aria-pressed', _this3.showExactSupplyIntegers ? 'true' : 'false');
          root.querySelectorAll('[data-supply-compact-value]').forEach(function (value) {
            value.hidden = _this3.showExactSupplyIntegers;
          });
          root.querySelectorAll('[data-supply-exact-value]').forEach(function (value) {
            value.hidden = !_this3.showExactSupplyIntegers;
          });
        };
      }
    }
  }]);
}();
module.exports = Supply;